import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'tran-about',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './about.component.html'
})
export class AboutComponent {}
